import { type FC } from 'react';

export const TroubleshootingSteps: FC = () => (
  <div className="mt-3">
    <p className="mb-2 text-sm font-medium">Try the following:</p>
    <ol className="list-inside list-decimal space-y-1 text-sm">
      <li>Ensure you're signed in with an account that has access to this subscription</li>
      <li>
        Reopen this SaaS subscription in the Azure portal or Microsoft 365 Admin Center and select "Configure Account"
        or "Manage Account" again
      </li>
    </ol>
    <p className="mt-3 text-sm">
      If the problem persists, contact support at{' '}
      <a href="mailto:support@youkeeps.com" className="underline hover:text-red-900">
        support@youkeeps.com
      </a>
    </p>
  </div>
);
